










































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus } from "./event-bus";
import Navbar from "./shared/Navbar.vue";
import axios from "axios";

@Component({
  name: "app",
  components: {
    Navbar
  }
})
export default class App extends Vue {
  snackbar: boolean = false;
  timeout: Number = 0;
  color: string = "";
  snackbarText: string = "";

  private created() {
    EventBus.$on("api-success", (payLoad: any) => {
      this.snackbarText = "";

      this.color = "success";
      this.timeout = 3000;
      this.snackbarText = payLoad.message;

      this.snackbar = true;
    });

    EventBus.$on("api-error", (errors: any) => {
      this.snackbarText = "";
      let error: string;

      if (errors instanceof Array) {
        error = errors[0].msg;
      } else {
        error = errors.message;
      }

      this.color = "error";
      this.timeout = 5000;
      this.snackbarText = error;

      this.snackbar = true;
    });

    EventBus.$on("request-error", (payLoad: any) => {
      console.log(payLoad);
    });
    EventBus.$on("internal-error", (payLoad: any) => {
      console.log(payLoad);
    });
  }

  private destroyed() {
    EventBus.$off("api-error");
    EventBus.$off("request-error");
    EventBus.$off("internal-error");
  }
}
